import type { SettingsFlow } from '@ory/client'

import { useIdentityLocale } from '@i18n/hooks/useIdentityLocale'

import type { SubmittedContext } from '../SettingsPage.utils'

// Settings-page wiring for useIdentityLocale: `traits.locale` governs the
// language on every mount (there is no switcher here to preserve a choice
// against). The only local decision left is telemetry attribution — a mount
// right after a Profile-tab save is the user having just changed the trait
// themselves, which funnel analysis reads differently from us adopting a
// pre-existing preference.
export const useLocaleReconcile = (
  flow: SettingsFlow | null,
  justUpdated: boolean,
  submittedContext: SubmittedContext | null,
): void => {
  const profileJustSaved =
    justUpdated && submittedContext !== null && submittedContext.tab === 'profile'

  useIdentityLocale({
    identity: flow?.identity,
    source: profileJustSaved ? 'settings-save' : 'identity-trait',
  })
}
